import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  padding: ${({ isDismissible }) =>
		isDismissible ? '0 8px 0 12px' : '0 12px'};
  border: 1px solid ${colors.grey4};
  width: fit-content;
  border-radius: 16px;
  justify-content: center;
  box-sizing: border-box;
  color: ${colors.grey7};
  cursor: pointer;

  &:hover {
    border-color: ${colors.green2};
    color: ${colors.green2};
    font-weight: 500;
  }

  ${({ isDisabled }) =>
		isDisabled &&
		css`
			pointer-events: none;
			border-color: ${colors.grey2};
			color: ${colors.grey5};
		`}

  ${({ isSelected }) =>
		isSelected &&
		css`
			font-weight: 500;
			border-color: ${colors.green1};
			box-shadow: 0 0 0 1px ${colors.green1} inset;
			color: ${colors.green2};

			&:hover {
				border-color: ${colors.green1};
				color: ${colors.green2};
			}
		`}

  ${({ isActive, isDisabled }) =>
		isActive &&
		css`
			font-weight: 500;
			background-color: ${isDisabled ? colors.grey3 : colors.green1};
			border: none;
			color: white;

			&:hover {
				border: none;
				color: white;
			}
		`}
`;

export const Label = styled.div`
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	text-align: center;
	max-width: 250px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	&::before {
		display: block;
		content: attr(title);
		font-weight: bold;
		height: 0;
		overflow: hidden;
		visibility: hidden;
	}
`;

export const IconWrapper = styled.div`
	display: flex;
	margin-left: 7px;
	cursor: pointer;
`;

export const FilterChipGroup = styled.div`
	display: flex;
	padding: 8px 32px 0 8px;
	flex-wrap: wrap;

	> div {
		margin: 0 8px 8px 0;
	}
`;
